import { MSym } from '@storeo/ui';
import { DemoBanner, PlaceholderTag } from '../components/lumina/Placeholder';

/** Admin · Bots & Automação — nova (Fluxo 4 Fase 2), 100% ilustrativa. A Storeo TEM um módulo
 *  de bot (Telegram, `com.storeo.bot`) e campanhas — mas por loja, sem visão agregada/global
 *  pro admin (nenhum endpoint `/api/admin/...` expõe isso hoje). Números abaixo são fictícios. */
export function Bots() {
  return (
    <>
      <div className="relative overflow-hidden rounded-2xl bg-surface-container-low p-space-xl shadow-xl">
        <div className="relative z-10 flex flex-col gap-space-2xs">
          <h1 className="font-headline-lg text-headline-lg text-on-surface font-bold flex items-center gap-2">
            Bots & Automação <PlaceholderTag />
          </h1>
          <p className="font-body-md text-body-md text-on-surface-variant">
            A Storeo tem bot do Telegram e campanhas por loja — mas sem visão agregada pro admin hoje.
          </p>
        </div>
      </div>

      <DemoBanner>Nenhum endpoint admin expõe telemetria global de bots/campanhas — números abaixo são ilustrativos.</DemoBanner>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-space-md">
        <Kpi icon="smart_toy" label="Bots ativos na rede" value="—" />
        <Kpi icon="send" label="Disparos hoje" value="—" />
        <Kpi icon="mail" label="E-mails transacionais" value="—" />
        <Kpi icon="webhook" label="Fila de webhooks" value="—" />
      </div>

      <section className="bg-surface-container-low rounded-2xl p-space-md shadow-lg overflow-hidden opacity-80">
        <div className="flex items-center gap-space-xs px-space-sm pb-space-sm">
          <MSym name="dns" className="text-primary text-[20px]" />
          <h2 className="font-headline-sm text-headline-sm text-on-surface font-bold">Filas de Automação (exemplo)</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-outline font-label-sm text-label-sm uppercase tracking-wider bg-surface-container-lowest/60">
                <th className="py-space-sm px-space-md rounded-l-lg">Fila</th>
                <th className="py-space-sm px-space-sm">Tipo</th>
                <th className="py-space-sm px-space-sm">Canal</th>
                <th className="py-space-sm px-space-md rounded-r-lg text-right">Status</th>
              </tr>
            </thead>
            <tbody className="text-body-sm font-body-sm">
              {[
                { queue: 'queue-order-paid', type: 'Convite pro grupo Telegram', channel: 'Telegram Bot' },
                { queue: 'queue-campaign-broadcast', type: 'Broadcast de campanha', channel: 'Telegram Bot' },
                { queue: 'queue-order-shipped', type: 'Notificação de envio', channel: 'E-mail' },
              ].map((r) => (
                <tr key={r.queue} className="border-t border-surface-container-highest/20">
                  <td className="py-space-md px-space-md font-mono text-on-surface">{r.queue}</td>
                  <td className="py-space-md px-space-sm text-on-surface-variant">{r.type}</td>
                  <td className="py-space-md px-space-sm text-outline">{r.channel}</td>
                  <td className="py-space-md px-space-md text-right text-outline">—</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

function Kpi({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="rounded-xl bg-surface-container-low p-space-md shadow-md flex flex-col gap-space-2xs">
      <div className="flex items-center justify-between">
        <span className="font-label-sm text-label-sm uppercase tracking-wider text-outline">{label}</span>
        <MSym name={icon} className="text-[18px] text-outline" />
      </div>
      <span className="font-headline-sm text-headline-sm text-outline font-bold">{value}</span>
    </div>
  );
}
